import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "cover-auth" }
const _hoisted_2 = { class: "widget-auth" }
const _hoisted_3 = {
  key: 0,
  class: "kyc-consultation"
}
const _hoisted_4 = { class: "kyc-section mb-6" }
const _hoisted_5 = { class: "kyc-photo-display" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "kyc-section mb-6" }
const _hoisted_8 = { class: "kyc-info-row" }
const _hoisted_9 = { class: "kyc-value" }
const _hoisted_10 = { class: "kyc-info-row" }
const _hoisted_11 = { class: "kyc-value" }
const _hoisted_12 = { class: "kyc-documents mt-4" }
const _hoisted_13 = {
  key: 0,
  class: "kyc-document-item"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 1,
  class: "kyc-document-item"
}
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "kyc-section mb-6" }
const _hoisted_18 = { class: "kyc-documents" }
const _hoisted_19 = {
  key: 0,
  class: "kyc-document-item"
}
const _hoisted_20 = ["href"]
const _hoisted_21 = {
  key: 1,
  class: "kyc-document-item"
}
const _hoisted_22 = ["href"]
const _hoisted_23 = {
  key: 2,
  class: "kyc-document-item"
}
const _hoisted_24 = ["href"]
const _hoisted_25 = {
  key: 1,
  class: "kyc-edition"
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "custom-upload-st2" }
const _hoisted_28 = {
  key: 0,
  src: "/public/icons/icon-photo.svg",
  width: "45%",
  class: "icon-white"
}
const _hoisted_29 = { class: "s10" }
const _hoisted_30 = { class: "custom-upload-text-sm" }
const _hoisted_31 = { class: "form-field-split active rounded-20 mt-5 my-6" }
const _hoisted_32 = { class: "form-field-floating full lg w-40" }
const _hoisted_33 = { class: "form-field-floating lg reactive w-60" }
const _hoisted_34 = { class: "custom-upload-st2" }
const _hoisted_35 = {
  key: 0,
  src: "/public/icons/icon-idcard-recto.svg",
  width: "45%",
  class: "icon-white"
}
const _hoisted_36 = { class: "s10" }
const _hoisted_37 = { class: "custom-upload-text-sm" }
const _hoisted_38 = { class: "custom-upload-st2" }
const _hoisted_39 = {
  key: 0,
  src: "/public/icons/icon-idcard-verso.svg",
  width: "45%",
  class: "icon-white"
}
const _hoisted_40 = { class: "s10" }
const _hoisted_41 = { class: "custom-upload-text-sm" }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { class: "custom-upload-st2" }
const _hoisted_44 = { class: "s12" }
const _hoisted_45 = { class: "custom-upload-text-sm" }
const _hoisted_46 = { class: "custom-upload-st2" }
const _hoisted_47 = { class: "s12" }
const _hoisted_48 = { class: "custom-upload-text-sm" }
const _hoisted_49 = { class: "custom-upload-st2" }
const _hoisted_50 = { class: "s12" }
const _hoisted_51 = { class: "custom-upload-text-sm" }
const _hoisted_52 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[68] || (_cache[68] = _createElementVNode("h2", { class: "font-semibold text-center mb-7" }, "Informations KYC", -1)),
      (!_ctx.isEditing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[14] || (_cache[14] = _createElementVNode("h4", { class: "text-primary-color mb-4" }, "Photo de profil", -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: _ctx.kycData.photoProfilUrl || '/public/assets/users/300w/user2.jpg',
                  class: "kyc-photo-preview rounded-20",
                  alt: "Photo de profil"
                }, null, 8, _hoisted_6)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[21] || (_cache[21] = _createElementVNode("h4", { class: "text-primary-color mb-4" }, "Pièce d'identité", -1)),
              _createElementVNode("div", _hoisted_8, [
                _cache[15] || (_cache[15] = _createElementVNode("span", { class: "kyc-label" }, "Type :", -1)),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.formatPieceType(_ctx.kycData.pieceIdentiteType)), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "kyc-label" }, "Numéro :", -1)),
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.kycData.numeroPiece || 'Non renseigné'), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                (_ctx.kycData.pieceRectoUrl)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _cache[17] || (_cache[17] = _createElementVNode("img", {
                        src: "/public/icons/icon-idcard-recto.svg",
                        class: "size-medium",
                        alt: ""
                      }, null, -1)),
                      _cache[18] || (_cache[18] = _createElementVNode("span", null, "Pièce recto", -1)),
                      _createElementVNode("a", {
                        href: _ctx.kycData.pieceRectoUrl,
                        target: "_blank",
                        class: "btn-sm"
                      }, "Voir", 8, _hoisted_14)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.kycData.pieceVersoUrl)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _cache[19] || (_cache[19] = _createElementVNode("img", {
                        src: "/public/icons/icon-idcard-verso.svg",
                        class: "size-medium",
                        alt: ""
                      }, null, -1)),
                      _cache[20] || (_cache[20] = _createElementVNode("span", null, "Pièce verso", -1)),
                      _createElementVNode("a", {
                        href: _ctx.kycData.pieceVersoUrl,
                        target: "_blank",
                        class: "btn-sm"
                      }, "Voir", 8, _hoisted_16)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[28] || (_cache[28] = _createElementVNode("h4", { class: "text-primary-color mb-4" }, "Bulletins de salaire", -1)),
              _createElementVNode("div", _hoisted_18, [
                (_ctx.kycData.bulletin1Url)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _cache[22] || (_cache[22] = _createElementVNode("span", { class: "kyc-doc-number" }, ".1", -1)),
                      _cache[23] || (_cache[23] = _createElementVNode("span", null, "Bulletin 1", -1)),
                      _createElementVNode("a", {
                        href: _ctx.kycData.bulletin1Url,
                        target: "_blank",
                        class: "btn-sm"
                      }, "Télécharger", 8, _hoisted_20)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.kycData.bulletin2Url)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _cache[24] || (_cache[24] = _createElementVNode("span", { class: "kyc-doc-number" }, ".2", -1)),
                      _cache[25] || (_cache[25] = _createElementVNode("span", null, "Bulletin 2", -1)),
                      _createElementVNode("a", {
                        href: _ctx.kycData.bulletin2Url,
                        target: "_blank",
                        class: "btn-sm"
                      }, "Télécharger", 8, _hoisted_22)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.kycData.bulletin3Url)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _cache[26] || (_cache[26] = _createElementVNode("span", { class: "kyc-doc-number" }, ".3", -1)),
                      _cache[27] || (_cache[27] = _createElementVNode("span", null, "Bulletin 3", -1)),
                      _createElementVNode("a", {
                        href: _ctx.kycData.bulletin3Url,
                        target: "_blank",
                        class: "btn-sm"
                      }, "Télécharger", 8, _hoisted_24)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startEditing && _ctx.startEditing(...args))),
              class: "btn lg w-100 flex-center mt-5"
            }, [...(_cache[29] || (_cache[29] = [
              _createElementVNode("img", {
                src: "/public/icons/settings-sliders.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Modifier mes informations", -1)
            ]))])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_25, [
            (_ctx.editStep === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _cache[47] || (_cache[47] = _createElementVNode("h3", { class: "font-semibold text-center mb-6" }, "Identité", -1)),
                  _createElementVNode("form", {
                    class: "form",
                    onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToNextStep && _ctx.goToNextStep(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("label", {
                      for: "file-upload-photo",
                      class: _normalizeClass(["custom-upload", { active: _ctx.formData.photoProfil }])
                    }, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("input", {
                          id: "file-upload-photo",
                          type: "file",
                          accept: "image/*",
                          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handlePhotoUpload && _ctx.handlePhotoUpload(...args)))
                        }, null, 32),
                        _createElementVNode("div", {
                          class: "s5 custom-upload-img",
                          style: _normalizeStyle(_ctx.photoPreviewStyle)
                        }, [
                          (!_ctx.photoPreview)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_28))
                            : _createCommentVNode("", true)
                        ], 4),
                        _createElementVNode("div", _hoisted_29, [
                          _cache[30] || (_cache[30] = _createElementVNode("span", { class: "custom-upload-text" }, "Photo de profil", -1)),
                          _cache[31] || (_cache[31] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.formData.photoProfil ? _ctx.formData.photoProfil.name : 'Charger la photo'), 1)
                        ]),
                        _cache[32] || (_cache[32] = _createElementVNode("div", { class: "s5 right" }, [
                          _createElementVNode("img", {
                            src: "/public/icons/icon-upload.svg",
                            class: "custom-upload-icon"
                          })
                        ], -1))
                      ])
                    ], 2),
                    _cache[45] || (_cache[45] = _createElementVNode("div", { class: "h-10" }, null, -1)),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _withDirectives(_createElementVNode("select", {
                          class: "form-input-select",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.pieceIdentiteType) = $event))
                        }, [...(_cache[33] || (_cache[33] = [
                          _createStaticVNode("<option value=\"\" data-v-4e9a4764>Type de pièce</option><option value=\"cni\" data-v-4e9a4764>CNI</option><option value=\"passport\" data-v-4e9a4764>Passeport</option><option value=\"permis\" data-v-4e9a4764>Permis de conduire</option><option value=\"carte_sejour\" data-v-4e9a4764>Carte de séjour</option>", 5)
                        ]))], 512), [
                          [_vModelSelect, _ctx.formData.pieceIdentiteType]
                        ]),
                        _cache[34] || (_cache[34] = _createElementVNode("label", null, [
                          _createTextVNode("Pièce d'identité "),
                          _createElementVNode("b", { class: "color-danger" }, "*")
                        ], -1))
                      ]),
                      _cache[36] || (_cache[36] = _createElementVNode("hr", { class: "hr" }, null, -1)),
                      _createElementVNode("div", _hoisted_33, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-input",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.numeroPiece) = $event)),
                          placeholder: ""
                        }, null, 512), [
                          [_vModelText, _ctx.formData.numeroPiece]
                        ]),
                        _cache[35] || (_cache[35] = _createElementVNode("label", null, [
                          _createTextVNode("N° de pièce d'identité "),
                          _createElementVNode("b", { class: "color-danger" }, "*")
                        ], -1))
                      ])
                    ]),
                    _createElementVNode("label", {
                      for: "file-upload-recto",
                      class: _normalizeClass(["custom-upload my-5", { active: _ctx.formData.pieceRecto }])
                    }, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("input", {
                          id: "file-upload-recto",
                          type: "file",
                          accept: "image/*,.pdf",
                          onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleRectoUpload && _ctx.handleRectoUpload(...args)))
                        }, null, 32),
                        _createElementVNode("div", {
                          class: "s5 custom-upload-img",
                          style: _normalizeStyle(_ctx.rectoPreviewStyle)
                        }, [
                          (!_ctx.rectoPreview)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_35))
                            : _createCommentVNode("", true)
                        ], 4),
                        _createElementVNode("div", _hoisted_36, [
                          _cache[37] || (_cache[37] = _createElementVNode("span", { class: "custom-upload-text uppercase" }, "Pièce recto", -1)),
                          _cache[38] || (_cache[38] = _createElementVNode("b", { class: "color-danger" }, "*", -1)),
                          _cache[39] || (_cache[39] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.formData.pieceRecto ? _ctx.formData.pieceRecto.name : 'Charger l\'image'), 1)
                        ]),
                        _cache[40] || (_cache[40] = _createElementVNode("div", { class: "s5 right" }, [
                          _createElementVNode("img", {
                            src: "/public/icons/icon-upload.svg",
                            class: "custom-upload-icon"
                          })
                        ], -1))
                      ])
                    ], 2),
                    _createElementVNode("label", {
                      for: "file-upload-verso",
                      class: _normalizeClass(["custom-upload", { active: _ctx.formData.pieceVerso }])
                    }, [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("input", {
                          id: "file-upload-verso",
                          type: "file",
                          accept: "image/*,.pdf",
                          onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleVersoUpload && _ctx.handleVersoUpload(...args)))
                        }, null, 32),
                        _createElementVNode("div", {
                          class: "s5 custom-upload-img",
                          style: _normalizeStyle(_ctx.versoPreviewStyle)
                        }, [
                          (!_ctx.versoPreview)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_39))
                            : _createCommentVNode("", true)
                        ], 4),
                        _createElementVNode("div", _hoisted_40, [
                          _cache[41] || (_cache[41] = _createElementVNode("span", { class: "custom-upload-text uppercase" }, "Pièce verso", -1)),
                          _cache[42] || (_cache[42] = _createElementVNode("b", { class: "color-danger" }, "*", -1)),
                          _cache[43] || (_cache[43] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.formData.pieceVerso ? _ctx.formData.pieceVerso.name : 'Charger l\'image'), 1)
                        ]),
                        _cache[44] || (_cache[44] = _createElementVNode("div", { class: "s5 right" }, [
                          _createElementVNode("img", {
                            src: "/public/icons/icon-upload.svg",
                            class: "custom-upload-icon"
                          })
                        ], -1))
                      ])
                    ], 2),
                    _cache[46] || (_cache[46] = _createElementVNode("button", {
                      type: "submit",
                      class: "btn lg w-100 flex-center mt-5"
                    }, " Suivant ", -1))
                  ], 32)
                ]))
              : _createCommentVNode("", true),
            (_ctx.editStep === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _cache[65] || (_cache[65] = _createElementVNode("h3", { class: "font-semibold text-center mb-6" }, "Bulletins de salaire", -1)),
                  _createElementVNode("form", {
                    class: "form",
                    onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmitKyc && _ctx.handleSubmitKyc(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("label", {
                      for: "file-upload-bulletin3",
                      class: _normalizeClass(["custom-upload my-5", { active: _ctx.formData.bulletin3 }])
                    }, [
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("input", {
                          id: "file-upload-bulletin3",
                          type: "file",
                          accept: ".pdf,.doc,.docx,.xls,.xlsx",
                          onChange: _cache[7] || (_cache[7] = (e) => _ctx.handleBulletinUpload(e, 3))
                        }, null, 32),
                        _cache[51] || (_cache[51] = _createElementVNode("div", { class: "s4 custom-upload-img" }, ".3", -1)),
                        _createElementVNode("div", _hoisted_44, [
                          _cache[48] || (_cache[48] = _createElementVNode("span", { class: "custom-upload-text" }, "Bulletin de salaire (3)", -1)),
                          _cache[49] || (_cache[49] = _createElementVNode("b", { class: "color-danger" }, "*", -1)),
                          _cache[50] || (_cache[50] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.formData.bulletin3 ? _ctx.formData.bulletin3.name : 'Charger le doc'), 1)
                        ]),
                        _cache[52] || (_cache[52] = _createElementVNode("div", { class: "s4 right" }, [
                          _createElementVNode("img", {
                            src: "/public/icons/icon-upload.svg",
                            class: "custom-upload-icon"
                          })
                        ], -1))
                      ])
                    ], 2),
                    _createElementVNode("label", {
                      for: "file-upload-bulletin2",
                      class: _normalizeClass(["custom-upload my-5", { active: _ctx.formData.bulletin2 }])
                    }, [
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("input", {
                          id: "file-upload-bulletin2",
                          type: "file",
                          accept: ".pdf,.doc,.docx,.xls,.xlsx",
                          onChange: _cache[8] || (_cache[8] = (e) => _ctx.handleBulletinUpload(e, 2))
                        }, null, 32),
                        _cache[56] || (_cache[56] = _createElementVNode("div", { class: "s4 custom-upload-img" }, ".2", -1)),
                        _createElementVNode("div", _hoisted_47, [
                          _cache[53] || (_cache[53] = _createElementVNode("span", { class: "custom-upload-text" }, "Bulletin de salaire (2)", -1)),
                          _cache[54] || (_cache[54] = _createElementVNode("b", { class: "color-danger" }, "*", -1)),
                          _cache[55] || (_cache[55] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.formData.bulletin2 ? _ctx.formData.bulletin2.name : 'Charger le doc'), 1)
                        ]),
                        _cache[57] || (_cache[57] = _createElementVNode("div", { class: "s4 right" }, [
                          _createElementVNode("img", {
                            src: "/public/icons/icon-upload.svg",
                            class: "custom-upload-icon"
                          })
                        ], -1))
                      ])
                    ], 2),
                    _createElementVNode("label", {
                      for: "file-upload-bulletin1",
                      class: _normalizeClass(["custom-upload my-5", { active: _ctx.formData.bulletin1 }])
                    }, [
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("input", {
                          id: "file-upload-bulletin1",
                          type: "file",
                          accept: ".pdf,.doc,.docx,.xls,.xlsx",
                          onChange: _cache[9] || (_cache[9] = (e) => _ctx.handleBulletinUpload(e, 1))
                        }, null, 32),
                        _cache[61] || (_cache[61] = _createElementVNode("div", { class: "s4 custom-upload-img" }, ".1", -1)),
                        _createElementVNode("div", _hoisted_50, [
                          _cache[58] || (_cache[58] = _createElementVNode("span", { class: "custom-upload-text" }, "Bulletin de salaire (1)", -1)),
                          _cache[59] || (_cache[59] = _createElementVNode("b", { class: "color-danger" }, "*", -1)),
                          _cache[60] || (_cache[60] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.formData.bulletin1 ? _ctx.formData.bulletin1.name : 'Charger le doc'), 1)
                        ]),
                        _cache[62] || (_cache[62] = _createElementVNode("div", { class: "s4 right" }, [
                          _createElementVNode("img", {
                            src: "/public/icons/icon-upload.svg",
                            class: "custom-upload-icon"
                          })
                        ], -1))
                      ])
                    ], 2),
                    _createElementVNode("button", {
                      type: "submit",
                      class: "btn lg w-100 flex-center mt-5",
                      disabled: _ctx.isSubmitting
                    }, [
                      _cache[63] || (_cache[63] = _createElementVNode("img", {
                        src: "/public/icons/icon-valider.svg",
                        class: "btn-icon",
                        alt: ""
                      }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.isSubmitting ? 'Enregistrement...' : 'Enregistrer'), 1)
                    ], 8, _hoisted_52),
                    _createElementVNode("a", {
                      onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToPreviousStep && _ctx.goToPreviousStep(...args)), ["prevent"])),
                      class: "cursor-pointer mt-4"
                    }, [...(_cache[64] || (_cache[64] = [
                      _createElementVNode("h5", { class: "flex-center gap-4 text-primary-color text-center" }, [
                        _createElementVNode("img", {
                          src: "/public/icons/icon-back.svg",
                          class: "size-medium",
                          alt: ""
                        }),
                        _createTextVNode(" Étape précédente ")
                      ], -1)
                    ]))])
                  ], 32)
                ]))
              : _createCommentVNode("", true)
          ])),
      (!_ctx.isEditing)
        ? (_openBlock(), _createElementBlock("a", {
            key: 2,
            onClick: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)), ["prevent"])),
            class: "cursor-pointer mt-5"
          }, [...(_cache[66] || (_cache[66] = [
            _createElementVNode("h5", { class: "flex-center gap-4 text-primary-color text-center" }, [
              _createElementVNode("img", {
                src: "/public/icons/icon-back.svg",
                class: "size-medium",
                alt: ""
              }),
              _createTextVNode(" Retour au profil ")
            ], -1)
          ]))]))
        : (_openBlock(), _createElementBlock("a", {
            key: 3,
            onClick: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cancelEditing && _ctx.cancelEditing(...args)), ["prevent"])),
            class: "cursor-pointer mt-4"
          }, [...(_cache[67] || (_cache[67] = [
            _createElementVNode("h5", { class: "flex-center gap-4 text-grey-600 text-center" }, " Annuler ", -1)
          ]))]))
    ])
  ]))
}